
//Our mapping of cognito user attributes to our user attributes for nice names - will need to extend this with other data and input field types, messages etc.
export enum CognitoUserAttributes {
    family_name = 'Last Name',
    given_name = 'First Name',
    phone_number = 'Phone Number',
}

//Our mapping of cognito user attributes to a user friendly message for the input field
export enum CognitoUserAttributeUserMessage {
    family_name = 'Minimum 2 characters, no numbers or special characters',
    given_name = 'Minimum 2 characters, no numbers or special characters',
    phone_number = 'International Phone Number to begin with +, no spaces or other special characters',
}

//Our mapping of cognito user attributes to a user friendly message for the input field
export enum CognitoUserAttributeErrorMessage {
    family_name = 'Please enter a valid name',
    given_name = 'Please enter a valid name',
    phone_number = 'Please enter a valid international phone number', 
}


// Our mapping of cognito user attributes for input fields with validation
export const CognitoUserAttributeFields = {
    family_name : {
        title: CognitoUserAttributes.family_name, //The label of the input field
        type: 'text', //The type of input field
        message: CognitoUserAttributeUserMessage.family_name, //The message to display below the input field
        sortOrder: 1, //The order to display the input field
        regex: /^[a-zA-Z]+(?:[ '-][a-zA-Z]+)*$/, //The regex to validate the input field
        regexMessage: CognitoUserAttributeErrorMessage.family_name, //The message to display if the regex fails
        required: true, //Whether the input field is required
        minLength: 2, //The minimum length of the input field
        maxLength: 50, //The maximum length of the input field
        default: '', //The default value of the input field
    },
    given_name : {
        title: CognitoUserAttributes.given_name,
        type: 'text',
        message: CognitoUserAttributeUserMessage.given_name,
        sortOrder: 0,
        regex: /^[a-zA-Z]+(?:[ '-][a-zA-Z]+)*$/,
        regexMessage: CognitoUserAttributeErrorMessage.given_name,
        required: true,
        minLength: 2,
        maxLength: 50,
        default: '',
    },
    phone_number : {
        title: CognitoUserAttributes.phone_number,
        type: 'tel',
        message: CognitoUserAttributeUserMessage.phone_number,
        sortOrder: 2,
        regex: /^\+\d{8,20}$/,
        regexMessage: CognitoUserAttributeErrorMessage.phone_number,
        required: true,
        minLength: 8,
        maxLength: 50,
        default: '+1',
    },
};